import React, { useEffect, useState } from "react";
import "./styles/BhpBizCard.css";
import {
  BhpMarketTypes,
  BhpThemeHeaderWithBack,
} from "../pages/BussinessHomePage";
import { userActionsTable, useRecordUserInteractions } from "../app/hooks";
import { getPageType, whatsappMessage } from "../types/constants";
import { callPhone } from "../common/commonFunctions";
import {
  IonButton,
  IonContent,
  IonFooter,
  IonIcon,
  IonPopover,
} from "@ionic/react";
import { call, callSharp, close, logoWhatsapp } from "ionicons/icons";
import { isMobileNumber } from "../types/bhp_common_function";

const BhpPhoneContact: React.FC<{
  phone: string;
  isWhatsapp?: boolean;
  name?: string;
  recordUserInteraction?: boolean;
  isMarket?: boolean;
  marketType?: BhpMarketTypes;
  pageId?: string | number;
  pageSection?: "MAIN";
  openDecider: (phone: string) => void;
}> = (props) => {
  const recordAction = useRecordUserInteractions();
  const sendWhatsappExec = () => {
    if (props.recordUserInteraction) {
      recordAction({
        action: userActionsTable.whatsapp,
        pageId: props.pageId,
        pageSection: props.pageSection,
        pageType: getPageType(props.isMarket, props.marketType),
        notes: props.phone,
      });
    }
    whatsappMessage(`Hi ${props.name}`, props.phone);
  };
  const callExec = () => {
    if (props.recordUserInteraction) {
      recordAction({
        action: userActionsTable.call,
        pageId: props.pageId,
        pageSection: props.pageSection,
        pageType: getPageType(props.isMarket, props.marketType),
        notes: props.phone,
      });
    }
    // window.open(`tel:${props.phone}`);
    callPhone(props.phone);
  };
  return (
    <>
      <div
        style={{
          padding: "10px",
          borderBottom: "1px solid var(--ion-color-medium)",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
        onClick={() => {
          if (isMobileNumber(props.phone)) props.openDecider(props.phone);
          else callExec();
        }}
      >
        <div>{props.phone}</div>
        <div style={{ display: "flex" }}>
          {!!props.isWhatsapp && (
            <div
              className={`bhp-biz-card-call-btns whatsapp-${props.phone}`}
              style={{ background: "var(--ion-color-primary)" }}
              onClick={(e) => {
                e.stopPropagation();
                sendWhatsappExec();
              }}
            >
              <IonIcon
                className={`bhp-biz-card-call-btns-whatsapp-${props.phone}`}
                icon={logoWhatsapp}
              />
            </div>
          )}
          <div
            className={`bhp-biz-card-call-btns phone-${props.phone}`}
            style={{
              marginLeft: "15px",
            }}
            onClick={(e) => {
              e.stopPropagation();
              callExec();
            }}
          >
            <IonIcon
              className={`bhp-biz-card-call-btns-phone-${props.phone}`}
              icon={call}
            />
          </div>
        </div>
      </div>
    </>
  );
};

const BhpContactCard: React.FC<{
  open: boolean;
  dismiss: () => void;
  phones: string[];
  extraPhones?: { name: string; phones: string[] }[];
  name?: string;
  recordUserInteraction?: boolean;
  isMarket?: boolean;
  marketType?: BhpMarketTypes;
  pageId?: string | number;
  pageSection?: "MAIN";
  save?: () => void;
}> = (props) => {
  const [openDecider, setOpenDecider] = useState("");
  const recordAction = useRecordUserInteractions();
  const sendWhatsappExec = (phone) => {
    if (props.recordUserInteraction) {
      recordAction({
        action: userActionsTable.whatsapp,
        pageId: props.pageId,
        pageSection: props.pageSection,
        pageType: getPageType(props.isMarket, props.marketType),
        notes: phone,
      });
    }
    whatsappMessage(`Hi ${props.name}`, phone);
  };
  const callExec = (phone) => {
    if (props.recordUserInteraction) {
      recordAction({
        action: userActionsTable.call,
        pageId: props.pageId,
        pageSection: props.pageSection,
        pageType: getPageType(props.isMarket, props.marketType),
        notes: phone,
      });
    }
    // window.open(`tel:${props.phone}`);
    callPhone(phone);
  };
  return (
    <>
      <IonPopover
        isOpen={!!openDecider}
        onDidDismiss={() => {
          setOpenDecider("");
        }}
        dismissOnSelect={true}
      >
        <BhpThemeHeaderWithBack
          title={openDecider}
          onBack={() => {
            setOpenDecider("");
          }}
        />
        <IonContent>
          {isMobileNumber(openDecider) && (
            <IonButton
              expand="block"
              onClick={() => {
                sendWhatsappExec(openDecider);
              }}
            >
              <IonIcon icon={logoWhatsapp} slot="start" /> Whatsapp
            </IonButton>
          )}
          <IonButton
            expand="block"
            onClick={() => {
              callExec(openDecider);
            }}
            color={"tertiary"}
          >
            <IonIcon icon={callSharp} slot="start" /> Call
          </IonButton>
        </IonContent>
        <IonFooter>
          <IonButton
            fill="clear"
            expand="block"
            color={"danger"}
            onClick={() => {
              setOpenDecider("");
            }}
          >
            <IonIcon icon={close} slot="start" />
            Dismiss
          </IonButton>
        </IonFooter>
      </IonPopover>
      <IonPopover isOpen={props.open} onDidDismiss={props.dismiss}>
        <BhpThemeHeaderWithBack title="Contact Info" onBack={props.dismiss} />
        <IonContent>
          {props.phones?.map((el, idx) => {
            return (
              <BhpPhoneContact
                openDecider={(phone) => {
                  setOpenDecider(phone);
                }}
                key={idx}
                phone={el}
                isWhatsapp={isMobileNumber(el)}
                name={props.name}
                isMarket={props.isMarket}
                marketType={props.marketType}
                pageId={props.pageId}
                pageSection={props.pageSection}
                recordUserInteraction={props.recordUserInteraction}
              />
            );
          })}
          {!!props.extraPhones &&
            props.extraPhones.map((el, idx) => {
              return (
                <div key={idx}>
                  <div
                    style={{
                      padding: "10px",
                      color: "black",
                      background: "rgba(0,0,0,0.1)",
                      fontWeight: "bold",
                    }}
                  >
                    {el.name}
                  </div>
                  {el.phones.map((item, index) => {
                    return (
                      <BhpPhoneContact
                        openDecider={(phone) => {
                          setOpenDecider(phone);
                        }}
                        key={index}
                        phone={item}
                        isWhatsapp={index === 0}
                        isMarket={props.isMarket}
                        marketType={props.marketType}
                        pageId={props.pageId}
                        pageSection={props.pageSection}
                        recordUserInteraction={props.recordUserInteraction}
                        name={props.name}
                      />
                    );
                  })}
                </div>
              );
            })}
        </IonContent>
        <IonFooter>
          <IonButton onClick={props?.save} expand="block" color={"dark"}>
            Save As Contact
          </IonButton>
          <IonButton
            onClick={props.dismiss}
            expand="block"
            color={"danger"}
            fill="clear"
          >
            Dismiss
          </IonButton>
        </IonFooter>
      </IonPopover>
    </>
  );
};

export default BhpContactCard;
